import { render, staticRenderFns } from "./Extensions.vue?vue&type=template&id=38400ad4&scoped=true&"
import script from "./Extensions.vue?vue&type=script&lang=js&"
export * from "./Extensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38400ad4",
  null
  
)

export default component.exports